import { useColorMode } from "theme-ui";

export function AppLoader() {
  const [colorMode] = useColorMode();
  return (
    <div
      id="app-loader"
      style={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
        background: "white",
        height: "100vh",
        width: "100%",
      }}
    >
      <img
        alt="Kards"
        width="113px"
        height="113px"
        src={colorMode === "dark" ? "/img/kards/logoWhite.svg" : "/img/kards/logo.svg"}
      />
      <div className="bar-loader">
        <div className="bar"></div>
        <div className="bar"></div>
        <div className="bar"></div>
      </div>
    </div>
  );
}
